import { motion } from "framer-motion";
import { useEffect, useState } from "react";

interface CounterProps {
  from: number;
  to: number;
}

const Counter = (props: CounterProps) => {
  const { from, to } = props;
  const [count, setCount] = useState(from);

  useEffect(() => {
    let start = from;
    const end = to;
    const duration = 2000; // 2 seconds
    const stepTime = Math.abs(Math.floor(duration / (end - start)));

    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start >= end) clearInterval(timer);
    }, stepTime);

    return () => clearInterval(timer);
  }, [from, to]);

  return <motion.span>{`${count.toLocaleString()}+`}</motion.span>;
};

const StatsSection = () => {
  return (
    <section className="py-2">
      <div className="container">
        <div className="row text-center">
          <div className="col-md-4 mb-4">
            <h2 className="display-5 fw-bold">
              <Counter from={2900} to={3000} />
            </h2>
            <p>No. of Surgeries Done</p>
          </div>
          <div className="col-md-4 mb-4">
            <h2 className="display-5 fw-bold">
              <Counter from={0} to={10} />
            </h2>
            <p>Years of Experience</p>
          </div>
          <div className="col-md-4 mb-4">
            <h2 className="display-5 fw-bold">
              <Counter from={4900} to={5000} />
            </h2>
            <p>Happy Patients</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
